import { useEffect, useState } from 'react';
import type { SyncService, SyncState } from './index.ts';

/** The sync's state, kept current; undefined until the service is found. */
export function useSyncState(service: SyncService | undefined): SyncState | undefined {
  const [state, setState] = useState(service?.state());
  useEffect(() => {
    if (!service) return;
    setState(service.state());
    return service.subscribe(() => setState(service.state()));
  }, [service]);
  return state;
}
